export const MenuExportExcel = [
  "/vocs-inventory/combustion/report-fuel-volume",
  "/vocs-inventory/combustion/report-voc-emission",
  "/vocs-inventory/transportation-and-marketing/report-chemical-volume",
  "/vocs-inventory/flare/report-flare-volume",
  "/vocs-inventory/transportation-and-marketing/report-chemical-volume",
  "/vocs-inventory/transportation-and-marketing/report-voc-emission",
  "/vocs-inventory/flare/report-voc-emission",
  "/vocs-inventory/flare/report-government",
  "/vocs-inventory/tank/report-voc-emission",
  "/vocs-inventory/waste-water-treatment/report-voc-emission",
  "/vocs-inventory/fugitive/information-voc-result",
  "/vocs-inventory/fugitive/information-stop-voc",
  "/vocs-inventory/fugitive/report-voc-series",
  "/vocs-inventory/fugitive/report-voc-emission",
  "/vocs-inventory/others/report",
  "/production",
  "/report",
];
